import React from 'react';
import PropTypes from 'prop-types';

import {
	MButtonSwitch,
	MInputField,
	MSmartField,
	MRte,
} from '../../molecules';

export default function OProductBasicInfo({
	type,
	title,
	slug,
	video,
	order,
	price,
	category,
	webshop,
	categoryItems,
	description,
	seoTitle,
	seoDescription,
	onTypeChange,
	onTitleChange,
	onSlugChange,
	onVideoChange,
	onOrderChange,
	onPriceChange,
	onWebshopChange,
	onCategoryChange,
	onDescriptionChange,
	onSeoTitleChange,
	onSeoDescriptionChange,
}) {
	return (
		<section className="o-product-detail-info">
			<MButtonSwitch
				label="Type"
				items={['Huishoudelijk', 'Industrieel', 'Huren']}
				index={type}
				onChange={onTypeChange}
			/>
			<MInputField
				id="pbiTitle"
				label="Title"
				value={title}
				required
				onChange={onTitleChange}
				maxLength="45"
			/>
			<MInputField
				id="pbiSlug"
				label="Slug"
				value={slug}
				required
				onChange={onSlugChange}
			/>
			<MInputField
				id="pbiVideo"
				label="Video url (optioneel)"
				value={video}
				onChange={onVideoChange}
			/>
			<MInputField
				id="pbiOrder"
				label="Order"
				type="number"
				value={order}
				required
				onChange={onOrderChange}
			/>
			<MInputField
				id="pbiPrice"
				label="Price (optioneel)"
				type="number"
				value={price}
				onChange={onPriceChange}
			/>
			<MInputField
				id="pbiWebshop"
				label="webshop url (optioneel)"
				value={webshop}
				onChange={onWebshopChange}
			/>
			<MSmartField
				id="pbiCategory"
				label="Categorie"
				iconType="arrowDown"
				value={categoryItems.find(item => item.id === category)}
				items={categoryItems}
				required
				onSelect={option => (option ? onCategoryChange(option.id) : onCategoryChange(undefined))}
			/>
			<MRte
				id="pbiDescription"
				label="Beschrijving"
				value={description}
				required
				onChange={onDescriptionChange}
			/>
			<MInputField
				id="seoTitle"
				label="SEO titel (optioneel)"
				value={seoTitle}
				onChange={onSeoTitleChange}
				maxLength="60"
			/>
			<MInputField
				id="seoDescription"
				label="SEO omschrijving (optioneel)"
				value={seoDescription}
				onChange={onSeoDescriptionChange}
				maxLength="160"
			/>
		</section>
	);
}

OProductBasicInfo.propTypes = {
	title: PropTypes.string,
	type: PropTypes.number,
	slug: PropTypes.string,
	video: PropTypes.string,
	price: PropTypes.number,
	order: PropTypes.number,
	webshop: PropTypes.string,
	category: PropTypes.string,
	categoryItems: PropTypes.array,
	description: PropTypes.string,
	seoTitle: PropTypes.string,
	seoDescription: PropTypes.string,
	onTypeChange: PropTypes.func,
	onTitleChange: PropTypes.func,
	onSlugChange: PropTypes.func,
	onVideoChange: PropTypes.func,
	onOrderChange: PropTypes.func,
	onPriceChange: PropTypes.func,
	onWebshopChange: PropTypes.func,
	onCategoryChange: PropTypes.func,
	onDescriptionChange: PropTypes.func,
	onSeoTitleChange: PropTypes.func,
	onSeoDescriptionChange: PropTypes.func,
};

OProductBasicInfo.defaultProps = {
	title: '',
	type: 0,
	price: '',
	slug: '',
	video: '',
	order: 1,
	webshop: '',
	category: '',
	categoryItems: [],
	description: '',
	seoTitle: '',
	seoDescription: '',
	onTypeChange: undefined,
	onTitleChange: undefined,
	onSlugChange: undefined,
	onVideoChange: undefined,
	onOrderChange: undefined,
	onPriceChange: undefined,
	onWebshopChange: undefined,
	onCategoryChange: undefined,
	onDescriptionChange: undefined,
	onSeoTitleChange: undefined,
	onSeoDescriptionChange: undefined,
};



// WEBPACK FOOTER //
// ./src/components/organisme/cms/_organisme.product-basic-info.js